export default "__VITE_ASSET__DHi8N9y3__"